'use strict';

import $ from 'jquery';
import ellipsis from './utilities/jquery.ellipsis.js';
import 'ellipsis.js';
import { viewport } from './utilities/viewport';

let ctaDesc = $('.paragraph--type--call-to-action-internal-links .field--name-field-action-description');
let chapterDesc = $('.paragraph--type--ia-chapter-doc .field--name-field-ch-doc-desc');

jQuery(document).ready(function($){

	// using library ellipsis.js
	if ($('.path-frontpage').length) {
		Ellipsis({
			className: '.view-publications-listing .field--type-text-with-summary p, #block-homedatautilization .field--name-field-short-description',
			lines: 4
		});
	}

	// using library jquery.ellipsis.js
	if ($('.path-search').length || $('.page-node-type-listing-page').length || $('.path-frontpage').length || $('.path-project-evaluations').length) {
		$('.search__summary .field--type-text-with-summary, .view-latest-news-media .field--type-text-with-summary, .view-content .field--type-text-with-summary, .cta-tile__description').each(function(){
			let summary = $(this).find('p').length ? $(this).find('p') : $(this);
			summary.ellipsis({
				lines: 4,
				ellipClass: 'ellip',
				responsive: true
			});
		})
	}

	if ($('.paragraph--type--call-to-action-internal-links')) {
		ctaDesc.each(function(){
			$(this).ellipsis({
				lines: 7,
				ellipClass: 'ellip',
				responsive: true
			});
		})
	}

	if ($('.paragraph--type--ia-chapter-doc')) {
		chapterDesc.each(function(){
			let windowWidth = viewport().width;
			if ( windowWidth < 1070 && windowWidth > 760) {
				$(this).ellipsis({
					lines: 5,
					ellipClass: 'ellip',
					responsive: true
				});
			} else {
				$(this).ellipsis({
					lines: 10,
					ellipClass: 'ellip',
					responsive: true
				});
			}
		})
	}
})
